// extracted by mini-css-extract-plugin
export default {"container":"snowy-road__container___3ILiQ"};